const re = /\{\{([^\}]+?)\}\}/g;

const portTypeConverters: Record<string, (v: any) => any> = {
  number: (v) => Number(v),
  boolean: (v) => v === true || v === "true",
};

export const coercePortValue = (value: any, tipo: string): any => {
  if (value === undefined || value === null) return null;
  return portTypeConverters[tipo]?.(value) ?? value;
};

// Normaliza o formato legado (string[]) de listas de variáveis declaradas
// (nome/tipo) para o formato atual ({nome,tipo}[]), usado pelo nó Início
// (variáveis de campanha/disparo manual) e pelo nó Novo fluxo (parâmetros).
export const normalizeVariaveisList = (raw: any[]): { nome: string; tipo: string }[] =>
  (raw ?? []).map((item) => typeof item === "string" ? { nome: item, tipo: "string" } : item);

export const tpl = (s: string, inputs: Record<string, any>): string => {
  if (!s) return '';

  return s.replace(re, (match: string, p1: string) => {
    const val = inputs[p1];
    return val !== undefined && val !== null && val !== ''
      ? String(val)
      : `{{${p1}}}`;
  });
};
